var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "linkedin"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.8444 3.19995C19.363 3.19995 19.8604 3.40598 20.2272 3.77272C20.5939 4.13946 20.8 4.63686 20.8 5.15551V18.8444C20.8 19.363 20.5939 19.8604 20.2272 20.2272C19.8604 20.5939 19.363 20.8 18.8444 20.8H5.15551C4.63686 20.8 4.13946 20.5939 3.77272 20.2272C3.40598 19.8604 3.19995 19.363 3.19995 18.8444V5.15551C3.19995 4.63686 3.40598 4.13946 3.77272 3.77272C4.13946 3.40598 4.63686 3.19995 5.15551 3.19995H18.8444ZM18.3555 18.3555V13.1733C18.3555 12.3279 18.0197 11.5171 17.4219 10.9193C16.8241 10.3216 16.0133 9.98573 15.168 9.98573C14.3368 9.98573 13.3688 10.4942 12.8995 11.2568V10.1715H10.1715V18.3555H12.8995V13.5351C12.8995 12.7822 13.5057 12.1662 14.2586 12.1662C14.6217 12.1662 14.9699 12.3104 15.2266 12.5671C15.4833 12.8238 15.6275 13.172 15.6275 13.5351V18.3555H18.3555ZM6.99373 8.6364C7.42939 8.6364 7.84721 8.46333 8.15527 8.15527C8.46333 7.84721 8.6364 7.42939 8.6364 6.99373C8.6364 6.0844 7.90306 5.34128 6.99373 5.34128C6.55547 5.34128 6.13517 5.51538 5.82527 5.82527C5.51538 6.13517 5.34128 6.55547 5.34128 6.99373C5.34128 7.90306 6.0844 8.6364 6.99373 8.6364ZM8.35284 18.3555V10.1715H5.6444V18.3555H8.35284Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.a0a2d16f94751afc166c3c6508633a2d.svg";
export { ForwardRef as ReactComponent };